export const SEARCH_ITEM_REQUEST = 'SEARCH_ITEM_REQUEST';
export const SEARCH_ITEM_SUCCESS = 'SEARCH_ITEM_SUCCESS';
export const SEARCH_ITEM_FAILURE = 'SEARCH_ITEM_FAILURE';
export const FIND_RELATED_ITEM_REQUEST = 'FIND_RELATED_ITEM_REQUEST';
export const FIND_RELATED_ITEM_SUCCESS = 'FIND_RELATED_ITEM_SUCCESS';
export const FIND_RELATED_ITEM_FAILURE = 'FIND_RELATED_ITEM_FAILURE';
export const SET_SELECTED_ITEM = 'SET_SELECTED_ITEM';
export const SET_SELECTED_PARENT_ITEMS = 'SET_SELECTED_PARENT_ITEMS';

